// Opções de Status para filtros
export const statusOptions = [
    { value: 1, description: 'aprovado' },
    { value: 2, description: 'enviado' },
    { value: 3, description: 'cancelado pelo programa' },
    { value: 4, description: 'cancelado' },
    { value: 5, description: 'pendente' },
    { value: 6, description: 'entregue' }
];

// Opções de UF para filtros
export const ufOptions = [
    { value: 'SP', description: 'SP - São Paulo' },
    { value: 'RJ', description: 'RJ - Rio de Janeiro' },
    { value: 'MG', description: 'MG - Minas Gerais' },
    { value: 'BA', description: 'BA - Bahia' },
    { value: 'RS', description: 'RS - Rio Grande do Sul' },
    { value: 'PR', description: 'PR - Paraná' },
    { value: 'SC', description: 'SC - Santa Catarina' },
    { value: 'GO', description: 'GO - Goiás' },
    { value: 'DF', description: 'DF - Distrito Federal' },
    { value: 'PE', description: 'PE - Pernambuco' },
    { value: 'CE', description: 'CE - Ceará' },
    { value: 'AM', description: 'AM - Amazonas' }
];

// Opções de KIT para filtros
export const kitOptions = [
    { value: 1, description: 'Kit 1 - Clenil A' },
    { value: 2, description: 'Kit 2 - Clenil A + Aquoso' }
];

// Opções de Especialidades e Áreas de Atuação para filtros
export const especialidadesEAreasDeAtuacao = [
    { value: 'ALERGISTA', description: 'ALERGISTA' },
    { value: 'CARDIOLOGISTA', description: 'CARDIOLOGISTA' },
    { value: 'CLINICO_GERAL', description: 'CLÍNICO GERAL' },
    { value: 'ENDOCRINOLOGISTA', description: 'ENDOCRINOLOGISTA' },
    { value: 'FARMACEUTICO', description: 'FARMACÊUTICO' },
    { value: 'GERIATRA', description: 'GERIATRA' },
    { value: 'HEMATOLOGISTA', description: 'HEMATOLOGISTA' },
    { value: 'NEFROLOGISTA', description: 'NEFROLOGISTA' },
    { value: 'NEONATOLOGISTA', description: 'NEONATOLOGISTA' },
    { value: 'OTORRINOLARINGOLOGISTA', description: 'OTORRINOLARINGOLOGISTA' },
    { value: 'PEDIATRA', description: 'PEDIATRA' },
    { value: 'PNEUMOLOGISTA', description: 'PNEUMOLOGISTA' },
    { value: 'PNEUMOPEDIATRA', description: 'PNEUMOPEDIATRA' }
];